/**
 * Hero background video — ensure native MP4 never shows browser controls.
 */
function initHeroVideo() {
    document.querySelectorAll('.hero-video-native').forEach((video) => {
        video.removeAttribute('controls')
        video.controls = false

        const play = () => {
            video.play().catch(() => {})
        }

        if (video.readyState >= 2) {
            play()
        } else {
            video.addEventListener('loadeddata', play, { once: true })
        }
    })
}

document.addEventListener('DOMContentLoaded', initHeroVideo)

export default initHeroVideo
